import React from 'react'
import {HiArrowLeft} from 'react-icons/hi'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'

const ArrowLeft = styled(HiArrowLeft)`
    width:30px;
    height:30px;
    color:#999;
    padding:4px;
    cursor:pointer;
    &:hover{
        background:#F9A826;
        padding:4px;
        color:#fff;
        border-radius:50%;
    }
    @media(max-width:800px){
        width:24px;
        height:24px
    }    
`
const Kembali = styled('p')`
    font-size:1rem;
    color:#999;
    &:hover{
        color:#F9A826;
    }
    @media(max-width:800px){
        font-size:.8rem;
    }

`
const Div = styled('div')`
    display:flex;
    margin-left:80px;
    align-items:center;
    margin-top:20px;
    cursor: pointer;
    @media(max-width:800px){
        margin-left:10px;
    }
`
const LeftArrow = () => {
    const history = useHistory()
    const handleClick = () =>{
        history.push('/')
    }
    return(
            <Div onClick={handleClick}>
                <ArrowLeft />
                <Kembali>back</Kembali>
            </Div>
    )
}
export default LeftArrow